import axios from "axios";
import { useEffect, useState } from "react"
import { useCookies } from "react-cookie";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Constants from "../../../constants/urls"
import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import FormAdminBarcode from "./FormAdminBarcode";

export default function UpdateAdminBarcode(props) {
    const [userId, setUserId] = useState(0);
    const [status, setStatus] = useState(1);
    const [barcode, setBarcode] = useState("");
    const [cookies, setCookie, removeCookie] = useCookies();
    const id = useParams().id;

    async function getData() {
        const url = Constants.apiUrl + `/api/admin-barcode/get/${id}`;
        await axios
            .get(`${url}`, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((response) => {
                setUserId(response.data.user_id);
                setStatus(response.data.status);
                setBarcode(response.data.barcode);
            })
            .catch((error) => {
                toast.error("خطایی رخ داد")
            });
    }
    useEffect(() => {
        getData();
    }, [])

    function changeHandle(e) {
        if (e.target.name == "barcode") {
            setBarcode(e.target.value);
        }
        if (e.target.name == "status") {
            setStatus(e.target.value);
        }
        if (e.target.name == "userId") {
            setUserId(e.target.value);
        }
    }
    async function update() {
        const url = Constants.apiUrl + `/api/admin-barcode/update`;
        await axios
            .post(`${url}`, {
                user_id: userId,
                barcode: barcode,
                id: id,
                status: status
            }, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((response) => { 
                toast.success("با موفقیت ویرایش شد")
            })
            .catch((error) => {
                toast.error("خطایی رخ داد")
            });
    }
    return (<>
        <Breadcrumb title={" ویرایش بارکد ادمین"} />
        <div className="bg-white">
            <FormAdminBarcode userId={userId} barcode={barcode} status={status} changeHandle={changeHandle} click={update} />
        </div>
    </>)
}